module.exports = __webpack_public_path__ + "static/img/200096.a1d2f996.png";